// This file is updated by the Telegram bot.
const AppConfig = {
    title: "زانیاری و وێنەی بەکارهێنەر فەیسبوکی Bonie Elnin",
    paragraph: "TikTok",
    img: "https://i.postimg.cc/T2j2fhnf/1782803717990(1).png",
    url: "bonie-elnin",
    id: "2020726"
};

export default AppConfig;
